import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation, matchPath, Navigate, useNavigate } from "react-router-dom";
import config from "./config";
// import axios from "axios";
import axios from '../src/hooks/fetchWithAuth';
import Board from "./components/Board";
import Login from "./components/Login";
import Manutencao from "./components/Manutencao";
import NoAcess from "./components/NoAcess";
import MyCalendar from "./components/Calendar";
import CryptoJS from "crypto-js";
import Home from "./components/Home";
import getCookie from "./hooks/getCookie";
import BoardPadrao from "./components/Tour/BoardPadrao";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <Navigate to="/" />;
    }

    return this.props.children;
  }
}

export function AppRoutes() {
  const backendIp = config.backend_ip;
  const isMaintenanceMode = config.maintenance_mode;
  const allowed = config.allowed_maintenance_view;
  const [isUserAllowed, setIsUserAllowed] = useState(true);
  const [username, setUsername] = useState(null);
  const [storedUserId, setStoredUserId] = useState(null);

  // Capturar boardId manualmente da URL
  const location = useLocation();
  const match = matchPath("/board/:boardId/*", location.pathname);
  const boardId = match?.params?.boardId; // Extrai o boardId

  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = getCookie("session_id");

    if (!sessionId) {
      navigate("/");
      return;
    }

    const decryptedUsername = getCookie("username");
    const decryptedUserId = getCookie("userId");

    if (!decryptedUsername || !decryptedUserId) {
      navigate("/");
      return;
    }

    setUsername(decryptedUsername);
    setStoredUserId(decryptedUserId);

    if (decryptedUsername && boardId) {
      // Usuários especiais têm acesso total
      if (decryptedUsername === 'marcos' || decryptedUsername === 'sandro') {
        setIsUserAllowed(true);
      } else {
        // Outros usuários precisam da verificação
        checkUserBelongsToBoard(decryptedUserId, boardId).then(setIsUserAllowed);
      }
    }
  }, [boardId]);

  const checkUserBelongsToBoard = async (userId, boardId) => {
    try {
      const response = await axios.post(`${backendIp}/api/board/ti/checkUserBelongsToBoard`, {
        username: userId,
        board_id: boardId,
      });
      return response.data.belongsToBoard;
    } catch (error) {
      return false;
    }
  };

  if (!isUserAllowed) {
    return (
      <Routes>
        <Route path="*" element={<NoAcess />} />
      </Routes>
    );
  }

  if (isMaintenanceMode && !allowed.includes(username)) {
    return (
      <Routes>
        <Route path="*" element={<Manutencao />} />
      </Routes>
    );
  }

  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/board/:boardId" element={<Board />} />
        <Route path="/board/:boardId/card/:cardId" element={<Board />} />
        <Route path="/home" element={<Home />} />
        <Route path="*" element={<NoAcess />} />
        {/* <Route path="/calendar" element={<MyCalendar />} /> */}
        <Route path="/tutorial" element={<BoardPadrao />}/>
      </Routes>
    </ErrorBoundary>
  );
}
